<template>
  <v-toolbar color="error" dark height="100"> 
    <v-toolbar-title class="display-1 " >vue-circle-control-slider</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items class="">
      <v-btn icon href="https://www.npmjs.com/package/vue-circle-control-slider" target="_blank"><v-icon size="46px">mdi-npm</v-icon></v-btn>
      <v-menu bottom origin="center center" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-skype</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>tvcoproration</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-gmail</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>mr.1bilous@gmail.com</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn icon href="https://www.facebook.com/profile.php?id=100010936621691" target="_blank">
        <v-icon >mdi-facebook</v-icon>
      </v-btn>
      <v-btn icon href="https://www.linkedin.com/in/vasyl-bilous-b980b217b" target="_blank">
        <v-icon>mdi-linkedin</v-icon>
      </v-btn>
      <v-btn icon href="https://github.com/00King00/VueCircleControlSlider" target="_blank">
        <v-icon>mdi-github-circle</v-icon>
      </v-btn>
      <v-btn icon href="https://mr-bilous.firebaseapp.com" target="_blank"><v-icon>mdi-newspaper</v-icon></v-btn>
     </v-toolbar-items>
  </v-toolbar>
</template>
<script>
export default {
    
}
</script>
<style >
.v-toolbar-title{
  font-family: 'Alfa Slab One', cursive;
}
</style>
<style scoped>
.v-icon:hover{
  font-size: 60px !important;
}
</style>